/**
 * 修复线上js报错：TypeError: null is not an object (evaluating 'localStorage.getItem')
 * https://jira.huanleguang.com/browse/HUABAN-2009
 * @returns {void}
 */
export default function localStoragePolyfill() {
  if (typeof window !== "undefined") {
    if (!window.localStorage) {
      let storage = {};
      window.localStorage = {
        setItem: (key, value) => {
          storage[key] = value || "";
        },
        getItem: (key) => (key in storage ? storage[key] : null),
        removeItem: (key) => {
          delete storage[key];
        },
        clear: () => {
          storage = {};
        },
      };
    }
  }
}
